import { produce } from 'immer';

import * as Types from './types';
import { actionTypes } from './constants';

export const defaultState: Types.IGamesConfigurationState = {
    games: {},
    gamesFeeds: {},
    excludedGameCodes: [],
    gameTypes: [],
    isGamesLoaded: false,
    favoriteGames: undefined,
    basicGameTileLayout: undefined,
    liveGameTileLayout: undefined,
    basicGameInfoLayout: undefined,
    liveGameInfoLayout: undefined
};

export const reducer = produce((draftState, action: Types.TGamesConfigurationAction): Types.IGamesConfigurationState | void => {
    switch (action.type) {
        case actionTypes.GAMES_CONFIGURATION_UPDATE: {
            const {
                games,
                gameTypes,
                liveGameTileLayout,
                liveGameInfoLayout,
                basicGameInfoLayout,
                basicGameTileLayout
            } = action.payload;

            Object.assign(draftState, {
                games,
                gameTypes,
                liveGameInfoLayout,
                basicGameInfoLayout,
                liveGameTileLayout,
                basicGameTileLayout,
                isGamesLoaded: true
            });

            break;
        }

        case actionTypes.GAMES_CONFIGURATION_GAMES_FEED_ADD: {
            const { name } = action.payload;

            draftState.gamesFeeds[name] = action.payload;

            break;
        }

        case actionTypes.GAMES_FAVORITES_SET: {
            draftState.favoriteGames = action.payload;

            break;
        }

        case actionTypes.GAMES_CONFIGURATION_EXCLUDED_GAME_CODES_SET: {
            draftState.excludedGameCodes = action.payload;

            break;
        }

        case actionTypes.GAMES_FAVORITES_TOGGLE: {
            const { gameCodes, isFavorite } = action.payload;

            draftState.favoriteGames = draftState.favoriteGames || [];

            if (isFavorite) {
                draftState.favoriteGames = [...gameCodes, ...draftState.favoriteGames];
            } else {
                draftState.favoriteGames = draftState.favoriteGames.filter((game) => !gameCodes.includes(game));
            }

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
